var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "kh-skeleton-loader",
          rawName: "v-kh-skeleton-loader",
          value: {
            loading: _setup.translationloading,
            types: _setup.ClvrSkeletonLoaderTypeConst,
            type: "input",
          },
          expression:
            "{ loading: translationloading, types: ClvrSkeletonLoaderTypeConst, type: 'input' }",
        },
      ],
      staticClass: "clvr-config-element",
    },
    [
      _c(
        "div",
        { staticClass: "clvr-config-element__title" },
        [
          _c("span", { staticClass: "clvr-config-element__label" }, [
            _vm._v(_vm._s(_setup.labelTr)),
          ]),
          _vm._v(" "),
          _c(_setup.KhIcon, {
            attrs: { icon: "mdi-pencil" },
            on: {
              click: function ($event) {
                return _setup.openTranslationEdition(_setup.props.label)
              },
            },
          }),
          _vm._v(" "),
          _c(_setup.KhIcon, {
            attrs: { icon: "mdi-history" },
            on: {
              click: function ($event) {
                return _setup.openHistory(_setup.props.label)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "clvr-config-element__description" }, [
        _vm._v(_vm._s(_setup.descriptionTr)),
      ]),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { "no-gutters": "", dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c(
                _setup.mappedComponent?.name,
                _vm._b(
                  {
                    tag: "component",
                    attrs: { context: _setup.props.context },
                    model: {
                      value: _setup.customComponentValue,
                      callback: function ($$v) {
                        _setup.customComponentValue = $$v
                      },
                      expression: "customComponentValue",
                    },
                  },
                  "component",
                  _setup.mappedComponent?.props,
                  false
                )
              ),
            ],
            1
          ),
          _vm._v(" "),
          _setup.sameAsGlobal && !!_setup.configStore.currentEstablishment
            ? _c(
                "v-col",
                { staticClass: "d-flex" },
                [
                  _c("v-subheader", { staticClass: "align-self-center" }, [
                    _vm._v(_vm._s(_setup.$t("system:config-inherit-global"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }